import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import DoctorLayout from "../Layout/DoctorLayout";
import PatientsIP from "../PatientsIP/PatientsIP";
import NurseCards from "./NurseCards";
import PatientTypeContextProvider from "../Layout/DoctorLayout/PatientTypeContextProvider";
import { UserContext } from "../../context/UserContext";
import { getCookie } from "../../helpers/localStorage";
import { FacilityID, Role } from "../../constants/defaultKeys";
import NoDataPage from "../NoDataPages/NoDataPage";
import patientDataIcon from "../../assets/images/nurseIcons/patientdata.svg";

const NurseView = () => {
  const location = useLocation();
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const { userDetails } = useContext(UserContext);
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const defaultFacility = userDetails?.currFacility || getCookie(FacilityID);
  const activeRoleObj = userDetails?.activeOrg?.roles?.find(
    (r) => r.role === defaultRole && r.facility_id === Number(defaultFacility)
  );

  const { ip_available, op_available } = activeRoleObj || {};

  return (
    <PatientTypeContextProvider>
      {params?.patient ? (
        <DoctorLayout>
          <PatientsIP />
        </DoctorLayout>
      ) : (
        <DoctorLayout header={true}>
          {!ip_available ? (
            <NoDataPage
              title={"No Patient Data"}
              subtitle={"Seems like, there are'nt any patient data"}
              image={patientDataIcon}
            />
          ) : (
            <NurseCards />
          )}
        </DoctorLayout>
      )}
    </PatientTypeContextProvider>
  );
};

export default NurseView;
